import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProposalService } from 'src/app/_services/proposal.service';

import { ActionModalComponent } from '../action-modal/action-modal.component';

@Component({
  selector: 'app-init-commission-button',
  templateUrl: './init-commission-button.component.html',
  styleUrls: ['./init-commission-button.component.css'],
  standalone: true,
  imports: [CommonModule, ActionModalComponent],
})
export class InitCommissionButtonComponent {
  @Input()
  proposalId!: string;

  @Input()
  buttonClass!: string;

  @Input()
  disabled!: boolean;

  @ViewChild('commissionModal') commissionModal!: ActionModalComponent;

  clicked = false;

  @Output()
  done = new EventEmitter();

  constructor(
    private readonly proposalService: ProposalService,
    private readonly toastrService: ToastrService
  ) {}

  initCommission() {
    if (this.clicked) return;
    this.clicked = true;
    this.proposalService.initProposalCommission(this.proposalId).subscribe({
      next: (res) => {
        this.commissionModal.closeModal();
        this.toastrService.success(
          $localize`Commissionnement lancé avec succès`
        );
        this.done.emit();
        this.clicked = false;
      },
      error: () => {
        this.commissionModal.closeModal();
        this.toastrService.error(
          $localize`Une erreur est survenue. Veuillez réessayer`
        );
        this.clicked = false;
      },
    });
  }
}
